// Route: /study-plan/templates — LEGACY redirect → /catalog?purpose=exam.
//
// «Шаблоны программ» больше не отдельный раздел: программы платформы лежат в
// ЕДИНОМ каталоге курсов вместе с курсами авторов и отличаются там осью
// «источник» + бейджем на карточке (`routes/catalog.tsx`). Ведём сразу на
// публичный адрес: `/courses/catalog` сам стал редиректом, и цепочка из двух
// переходов дала бы лишний кадр и лишнюю запись в истории.
//
// Редирект ведёт на срез `purpose=exam`: пользователь, пришедший по старой
// ссылке, искал подготовку к экзамену — открывать ему весь каталог значило бы
// потерять его запрос. Внутри среза он видит и авторские экзаменационные курсы,
// чего в прежнем разделе не было вовсе.
//
// `?templateId=` (deep-link на пресет с лендинга) переносится в `?preset=` —
// каталог по нему сразу открывает создание курса с prefill.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	country: z.string().optional(),
	subsystem: z.string().optional(),
	q: z.string().optional(),
	templateId: z.string().optional(),
	demo: z.enum(["default", "loading", "empty", "error"]).optional(),
});

export const Route = createFileRoute("/study-plan/templates")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/catalog",
			search: {
				purpose: "exam",
				// Страна не переносится: у единого каталога ось — подсистема
				// экзамена (`ru:ege`), а не страна, и подставлять «RU» в фильтр
				// подсистемы значило бы обнулить выдачу.
				...(search.subsystem ? { exam: search.subsystem } : {}),
				...(search.q ? { q: search.q } : {}),
				...(search.templateId ? { preset: search.templateId } : {}),
			},
			replace: true,
		});
	},
});
